export default "__VITE_ASSET__BVMaKP77__$_?url__"